import { Box, Grid, Text } from '@simplywallst/ui-core';
import NarrativesEmptyPanelCard from './narratives-empty-panel-card.svg';

export const NarrativesEmptyPanel = () => {
  return (
    <Grid
      width="100%"
      padding="x2"
      paddingMd="x6"
      justifyContent="center"
      role="alert"
    >
      <Box position="relative">
        <Grid
          templateColumnsMd="repeat(2, 164px)"
          templateColumns="repeat(2, minmax(50px, 164px))"
          templateRows="repeat(2, auto)"
          gap="4px"
          opacity="0.5"
        >
          <NarrativesEmptyPanelCard width="100%" height="auto" />
          <NarrativesEmptyPanelCard width="100%" height="auto" />
          <NarrativesEmptyPanelCard width="100%" height="auto" />
          <NarrativesEmptyPanelCard width="100%" height="auto" />
        </Grid>
        <Box
          position="absolute"
          top="0"
          bottom="0"
          left="0"
          right="0"
          padding="x2"
        >
          <Grid alignItems="center" height="100%">
            <Text color="textSofter" textAlign="center">
              There is no community narrative available for this company
            </Text>
          </Grid>
        </Box>
      </Box>
    </Grid>
  );
};
